'use client';
import useSticky from '@/app/_hooks/useSticky';
import SpAddToCartButton from './SpAddToCartButton';
import ScrollToSection from '../share/ScrollToSection';
import { useProductContext } from '@/app/_providers/ProductContext';

export default function SpNavigationCenter({
  product,
  catalog,
  attr,
  video,
  compare,
  relatedProducts,
}) {
  const { sticky, stickyRef } = useSticky();
  const { currentVariation } = useProductContext();

  return (
    <>
      <div className=" mt-4 lg:mt-0">
        <div className="hidden lg:block">
          <div ref={stickyRef}></div>
          <div
            id="spNvigationCenter"
            className={`spNvigationCenter bg-white  z-20 mr-0 ${
              sticky
                ? 'fixed top-0 bg-white w-full mt-0 pb-3   left-0 right-0 py-2 shadow-md  '
                : 'relative  mt-8 pt-8'
            }`}
          >
            <div className="container flex items-center justify-between text-sm">
              <ul className={` flex  px-4 ${sticky ? 'mr-0 pt-2' : ''} `}>
                <li className="pl-4 text-color-primary  font-bold">
                  <ScrollToSection sectionId="spDescription">
                    <div className="border border-color-primary rounded-full  p-2">
                      ویژگی ها و نقد و بررسی محصول
                    </div>
                  </ScrollToSection>
                </li>
                {relatedProducts && (
                  <li className="pl-4">
                    <ScrollToSection sectionId="spRelatedProducts">
                      <div className="border border-gray-heavy rounded-full p-2">
                        محصولات مرتبط
                      </div>
                    </ScrollToSection>
                  </li>
                )}

                {attr && (
                  <li className="pl-4">
                    <ScrollToSection sectionId="spFeatures">
                      <div className="border border-gray-heavy rounded-full p-2">
                        مشخصات فنی
                      </div>
                    </ScrollToSection>
                  </li>
                )}

                {catalog && (
                  <li className="pl-4">
                    <ScrollToSection sectionId="ُspCatalogs">
                      <div className="border border-gray-heavy rounded-full  p-2">
                        کاتالوگ
                      </div>
                    </ScrollToSection>
                  </li>
                )}
                {video && (
                  <li className="pl-4">
                    <ScrollToSection sectionId="spVideos">
                      <div className="border border-gray-heavy rounded-full  p-2">
                        ویدیوها
                      </div>
                    </ScrollToSection>
                  </li>
                )}
                {compare && (
                  <li className="pl-4">
                    <ScrollToSection sectionId="spCompareProduct">
                      <div className="border border-gray-heavy rounded-full  p-2">
                        مقایسه
                      </div>
                    </ScrollToSection>
                  </li>
                )}
                <li className="pl-4">
                  <ScrollToSection sectionId="spComments">
                    <div className="border border-gray-heavy rounded-full  p-2">
                      دیدگاه ها
                    </div>
                  </ScrollToSection>
                </li>
                <li className="pl-4">
                  <ScrollToSection sectionId="spAskAnswer">
                    <div className="border border-gray-heavy rounded-full  p-2">
                      پرسش ها
                    </div>
                  </ScrollToSection>
                </li>
              </ul>
              {sticky && (
                <div className="stickyAddToCart">
                  {!product.offline && (
                    <SpAddToCartButton
                      product={product}
                      price={currentVariation}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
